export default __webpack_public_path__ + "static/media/addResume.31be9ab9.jpg";